export enum Frequency {
  ONE_TIME = 'One Time',
  YEARLY = 'Yearly',
  MONTHLY = 'Monthly',
  WEEKLY = 'Weekly',
  DAILY = 'Daily',
  QUARTERLY = 'Quarterly',
  BI_WEEKLY = 'Bi-Weekly',
}

export enum Form {
  SHORT = 'short',
  LONG = 'long',
  VERBOSE = 'verbose',
}
